// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tq_T","left":"styles_left__2m7yX","desktopActions":"styles_desktopActions__3pZcf","title":"styles_title__3pqpZ"};